// extracted by mini-css-extract-plugin
export var alignDiscLeft = "v_rg d_fp d_bG d_dv";
export var alignLeft = "v_qt d_fp d_bG d_dv";
export var alignDiscCenter = "v_rh d_fq d_bD d_dw";
export var alignCenter = "v_bP d_fq d_bD d_dw";
export var alignDiscRight = "v_rj d_fr d_bH d_dx";
export var alignRight = "v_qv d_fr d_bH d_dx";
export var footerContainer = "v_rk d_dW d_bW";
export var footerContainerFull = "v_rl d_dT d_bW";
export var footerHeader = "v_kf d_kf";
export var footerTextWrapper = "v_rm d_w";
export var footerDisclaimerWrapper = "v_km d_km d_ck";
export var badgeWrapper = "v_rn d_w d_bz d_bP d_bF d_bJ";
export var verticalTop = "v_rp d_bz d_bJ d_bN d_bL";
export var wide = "v_rq d_cy";
export var right = "v_rr d_bK";
export var line = "v_fk d_fl d_cv";
export var badgeDisclaimer = "v_rs d_bC d_bP d_bJ";
export var badgeContainer = "v_rt d_bz d_bH d_bP";
export var badge = "v_rv";
export var padding = "v_rw d_c7";
export var end = "v_rx d_bH";
export var linkWrapper = "v_ry d_dB";
export var link = "v_mC d_dB";
export var colWrapper = "v_rz d_cx";
export var consent = "v_f d_f d_bC d_bP";
export var disclaimer = "v_rB d_bz d_bJ";
export var media = "v_rC d_bx d_dy";
export var itemRight = "v_rD";
export var itemLeft = "v_rF";
export var itemCenter = "v_rG";
export var exceptionWeight = "v_qB G_tn";